import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Card } from ".";
export const ErrorBox = ({ children }) => (_jsx("div", { css: { marginTop: 8 }, children: _jsx(Card, { kind: "error", children: children }) }));
/**
* If the given error is not `null` nor `undefined`, returns an `<ErrorBox>`
* with it as content. Returns `null` otherwise.
*/
export const boxError = (err) => (err == null ? null : _jsx(ErrorBox, { children: err }));
//# sourceMappingURL=errorBox.js.map